import { createRouter, createWebHistory } from 'vue-router';
import { routes as appRoutes } from './routes';

const appEl = document.querySelector('#app');
const hrefBase = appEl?.getAttribute('hrefbase') || '/';

const routes = [
  ...appRoutes
];

const router = createRouter({
  history: createWebHistory(hrefBase),
  routes
});

export default router;
